import { ProgramSettingsResp } from '@/storage/program_settings/requests.ts'
import { Status } from '@/common/constants.ts'

export const BASE_PATH = '/home/application' as const

const IDENTITY_PATH = `${BASE_PATH}/identity_verification` as const
const RESIDENCY_PATH = `${BASE_PATH}/residency_verification` as const
const STUDENT_PATH = `${BASE_PATH}/student_details` as const
const INCOME_PATH = `${BASE_PATH}/income_verification` as const
const ATTESTATION_PATH = `${BASE_PATH}/attestations` as const

export const FamilyApplicationPaths = {
  index: BASE_PATH,
  about: `${BASE_PATH}/about`,
  identity_verification: {
    index: IDENTITY_PATH,
    basic_info: `${IDENTITY_PATH}/basic_info`,
    submitted: `${IDENTITY_PATH}/submitted`,
    success_verification: `${IDENTITY_PATH}/success_verification`,
    success_manual_verification: `${IDENTITY_PATH}/success__manual_verification`,
    verify_information: `${IDENTITY_PATH}/verify_information`,
    manual_info: `${IDENTITY_PATH}/verify_information`,
    document_capture: `${IDENTITY_PATH}/document_capture`,
    document_review: `${IDENTITY_PATH}/document_review`,
  },
  residency_verification: {
    index: RESIDENCY_PATH,
    document_capture: `${RESIDENCY_PATH}/document_capture`,
    document_review: `${RESIDENCY_PATH}/document_review`,
    enter_details: `${RESIDENCY_PATH}/enter_details`,
    success_verification: `${RESIDENCY_PATH}/success_verification`,
    alternative_docs_info: `${RESIDENCY_PATH}/alternative_docs_info`,
    alternative_docs_capture: `${RESIDENCY_PATH}/alternative_docs_capture`,
    alternative_docs_review: `${RESIDENCY_PATH}/alternative_docs_review`,
    alternative_docs_verify: `${RESIDENCY_PATH}/alternative_docs_verify`,
  },
  student_details: {
    index: STUDENT_PATH,
    enter_details: `${STUDENT_PATH}/enter_details`,
    scholarships: `${STUDENT_PATH}/scholarships`,
    scholarship_warning: `${STUDENT_PATH}/scholarship_warning`,
    lea: `${STUDENT_PATH}/lea`,
    lea_warning: `${STUDENT_PATH}/lea_warning`,
    capture_instructions: `${STUDENT_PATH}/capture_instructions`,
    capture: `${STUDENT_PATH}/capture`,
    success_verification: `${STUDENT_PATH}/success_verification`,
    relationship: {
      index: `${STUDENT_PATH}/relationship/capture_instructions`,
      capture: `${STUDENT_PATH}/relationship/capture`,
      document_review: `${STUDENT_PATH}/relationship/document_review`,
      document_submitted: `${STUDENT_PATH}/relationship/document_submitted`,
    },
    photo_review: `${STUDENT_PATH}/photo_review`,
    special_education: {
      index: `${STUDENT_PATH}/special_education/document_type`,
      capture_instructions: `${STUDENT_PATH}/special_education/capture_instructions`,
      document_capture: `${STUDENT_PATH}/special_education/document_capture`,
      document_review: `${STUDENT_PATH}/special_education/document_review`,
      document_submitted: `${STUDENT_PATH}/special_education/document_submitted`,
    },
    document_submitted: `${STUDENT_PATH}/document_submitted`,
    enter_birthdate: `${STUDENT_PATH}/enter_birthdate`,
    confirm_birthdate: `${STUDENT_PATH}/confirm_birthdate`,
    additional_details: `${STUDENT_PATH}/additional_details`,
    additional_student: `${STUDENT_PATH}/additional_student`,
    attestations: {
      index: `${STUDENT_PATH}/attestations`,
      id: `${STUDENT_PATH}/attestations/:attestation_id`,
    },
  },
  income_verification: {
    index: INCOME_PATH,
    filing_status: `${INCOME_PATH}/filing_status`,
    household_size: `${INCOME_PATH}/household_size`,
    social_security_number: `${INCOME_PATH}/verify_income`,
    alternative_verification_method: `${INCOME_PATH}/select_income_type`,

    tax_commission_attestation: `${INCOME_PATH}/tax_commission_attestation`,
    tax_commission_confirmation: `${INCOME_PATH}/tax_commission_confirmation`,
    tax_commission: `${INCOME_PATH}/tax_commission`,
    tax_commission_verify_account: `${INCOME_PATH}/tax_commission_setup`,

    capture_instructions: `${INCOME_PATH}/capture_instructions`,
    document_instructions: `${INCOME_PATH}/document_instructions`,
    document_capture: `${INCOME_PATH}/document_capture`,
    document_review: `${INCOME_PATH}/document_review`,
    document_submitted: `${INCOME_PATH}/document_submitted`,
    select_household_member: `${INCOME_PATH}/select_household_member`,

    attestations: `${INCOME_PATH}/attestations`,
    success_verification: `${INCOME_PATH}/success_verification`,
    completed: `${INCOME_PATH}/completed`,
    skip: `${INCOME_PATH}/skip`,
  },
  attestations: {
    index: ATTESTATION_PATH,
    id: `${ATTESTATION_PATH}/:attestation_id`,
  },
  review_application: `${BASE_PATH}/review_application`,
  application_sent: `${BASE_PATH}/application_sent`,
} as const

export function getIdentityVerificationUrl(settings: ProgramSettingsResp) {
  if (
    settings.integrations.some(
      (integration) =>
        integration.code == 'CLEAR_ME' && integration.status == Status.Active
    )
  ) {
    return FamilyApplicationPaths.identity_verification.index
  } else {
    return FamilyApplicationPaths.identity_verification.manual_info
  }
}

export type FamilyApplicationPathsType = typeof FamilyApplicationPaths
